import Vue from 'vue'

export const appState = Vue.observable({
  active_account: null,
})

export function installAppState(VueInstance) {
  Object.defineProperty(VueInstance.prototype, '$active_account', {
    get() {
      return appState.active_account
    },
    set(value) {
      appState.active_account = value
    },
  })
}
